<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M204.8 443.744a68.256 68.256 0 1 1 0 136.512 68.256 68.256 0 0 1 0-136.512z m307.2 0a68.256 68.256 0 1 1 0 136.512 68.256 68.256 0 0 1 0-136.512z m307.2 0a68.256 68.256 0 1 1 0 136.512 68.256 68.256 0 0 1 0-136.512z"
      fill="currentColor"
    />
  </svg>
</template>
